import React, { useState } from 'react';
import { styled } from '@components-shared/src/stitches';

export const SquareSelector = ({
  items,
  onChange,
  size = 'large',
  initialSelectedId,
}: {
  items: { id: string; background: string }[];
  onChange: (id: string) => void;
  size?: 'large' | 'small';
  initialSelectedId: string;
}) => {
  const [selected, setSelected] = useState(initialSelectedId);

  return (
    <Container>
      {items.map(({ id, background }) => (
        <ItemWrapper key={id} isSelected={id === selected}>
          <Item
            css={{ background }}
            onClick={() => {
              setSelected(id);
              onChange(id);
            }}
            size={size}
          />
        </ItemWrapper>
      ))}
    </Container>
  );
};

const Container = styled('div', {
  display: 'flex',
  gap: 4,
});

const Item = styled('button', {
  border: '1px solid $neutral400',
  borderRadius: 4,

  variants: {
    size: {
      small: {
        height: 24,
        width: 24,
      },
      large: {
        height: 40,
        width: 40,
      },
    },
  },
});

const ItemWrapper = styled('div', {
  borderRadius: 5,
  border: '2px solid transparent',
  padding: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '&:hover': {
    borderColor: '$base300',
  },

  variants: {
    isSelected: {
      true: {
        borderColor: '$black',
        '&:hover': {
          borderColor: '$black',
        },
      },
    },
  },
});
